export default __webpack_public_path__ + "static/media/blue-correct.38e7f2c2.svg";